import { useMemo, useReducer, type ReactNode } from 'react'
import {
  chatSelectionInitialState,
  chatSelectionReducer,
  chatSelectionTokenKey,
} from '../types/aiChatSource'
import {
  ChatSelectionContext,
  type ChatSelectionContextValue,
} from './chatSelectionContextCore'

export const ChatSelectionProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(chatSelectionReducer, chatSelectionInitialState)
  const value = useMemo<ChatSelectionContextValue>(() => ({
    ...state,
    dispatch,
    setMode: (mode) => dispatch({ type: 'set-mode', mode }),
    toggleToken: (token) => dispatch({ type: 'toggle-token', token }),
    removeToken: (key) => dispatch({ type: 'remove-token', key }),
    clear: () => dispatch({ type: 'clear' }),
    hasToken: (token) => state.tokens.some((entry) => chatSelectionTokenKey(entry) === chatSelectionTokenKey(token)),
  }), [state])
  return <ChatSelectionContext.Provider value={value}>{children}</ChatSelectionContext.Provider>
}
